import React from 'react';
import classNames from 'classnames/bind';

import styles from './loadingSpinnerStyles';

export const SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  TINY: 'tiny',
  NANO: 'nano'
};

export const TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

const LoadingSpinner = ({ type = TYPES.PRIMARY, size = SIZES.LARGE, inlineBlock = false }) => {
  const cx = classNames.bind(styles);

  const loaderClassName = cx({
    loadingIcon: true,
    primary: type === TYPES.PRIMARY,
    secondary: type === TYPES.SECONDARY,
    large: size === SIZES.LARGE,
    medium: size === SIZES.MEDIUM,
    tiny: size === SIZES.TINY,
    nano: size === SIZES.NANO
  });

  const wrapperClassName = cx({
    loadingWrap: true,
    inlineBlock
  });

  return (
    <div className={wrapperClassName} data-testid="loading-spinner">
      <svg
        className={loaderClassName}
        width="35px"
        height="35px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={styles.loadingIconPath}
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
